import AbstractView from './AbstractView';
import { HIDDEN } from 'core/Classes';

class LoginRegister extends AbstractView {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.checkUrlHash = this.checkUrlHash.bind(this);
    this.showRecoverPasswordForm = this.showRecoverPasswordForm.bind(this);
    this.resetPasswordSuccess = this.resetPasswordSuccess.bind(this);
  }

  initializeBeforeEvents() {
    super.initializeBeforeEvents();
    this.checkUrlHash();
  }

  checkUrlHash() {
    var { hash } = window.location;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      const modal = this.modals.find((modal) => modal.id === 'modal-reset-password');

      if (modal) {
        modal.open();
      }
    }
  }

  showRecoverPasswordForm() {
    this.ui.$login.classList.add(HIDDEN);
    this.ui.$recover.classList.remove(HIDDEN);
  }

  resetPasswordSuccess() {
    // check if reset password form was successfully submited.
    if (this.ui.$recoverSuccess === null) {
      return;
    }

    const $success = this.ui.$element.querySelector('#ResetSuccess');
    $success.classList.remove(HIDDEN);
  }
}

export default LoginRegister;
